module.exports = __webpack_public_path__ + "static/media/wardrobe-shut2.4ca7526d.jpg";